// Japanese — partial translation seeded over the English catalogue.
// Every key not overridden here falls back to en.js (fallbackLocale)
// and the spread below keeps the full structure intact for tooling.
// Extend section by section; keep keys identical to en.js.
import en from "./en";

export default {
    ...en,
    Projects: {
        ...en.Projects,
        tasks: "タスク",
        save: "保存",
        cancel: "キャンセル",
        delete: "削除",
        status: "ステータス",
        priority: "優先度",
        due_date: "期限",
        assignee: "担当者",
        new_task: "新しいタスク",
        add_subtask: "サブタスクを追加",
        archive: "アーカイブ",
        duplicate: "複製",
        group_by: "グループ化",
        subtask: "サブタスク",
        expanded: "展開",
        collapsed: "折りたたみ",
        me: "自分",
        burndown: "バーンダウン",
        select_sprint: "スプリント",
        no_burndown_data: "このスプリントのデータはまだありません",
        recent_tasks: "最近",
        no_recent_tasks: "最近表示したタスクはありません",
        global_search: "全体検索",
        search_everything: "タスク、プロジェクト、コメントを検索...",
        no_search_results: "見つかりませんでした",
        epics: "エピック",
        add_epic: "追加",
        epic_name_placeholder: "新しいエピック名...",
        no_epics: "エピックはまだありません",
        select_epic: "エピックに追加",
        remove_from_epic: "エピックから外す",
        export_tasks: "エクスポート",
        export_preparing: "エクスポートを準備しています...",
        export_ready: "エクスポート完了 — ダウンロード中",
        export_failed: "エクスポートに失敗しました",
        pages: "ページ",
        add_page: "新規",
        no_pages: "ページはまだありません",
        select_page: "ページを選択または作成",
        save_page: "保存",
        untitled_page: "無題のページ",
        page_versions: "履歴",
        page_restored: "バージョンを復元しました",
        edit: "編集",
        preview: "プレビュー",
        insert_task_chip: "タスクチップを挿入",
        search_task: "タスク名またはキーで検索...",
        no_tasks_found: "タスクが見つかりません",
        unknown_status: "不明",
        public_link: "公開リンク",
        create_public_link: "公開リンクを作成",
        move_to_folder: "フォルダへ移動",
        no_folder_root: "フォルダなし（ルート）",
        select_folder: "このスプリントを移動するフォルダを選択",
        link_enabled: "リンク有効",
        allow_intake: "外部リクエストを受け付ける",
        intake_inbox: "リクエスト",
        no_intake: "保留中のリクエストはありません",
        anonymous: "匿名",
        accept: "承認",
        reject: "却下",
        import_jira: "Jiraインポート",
        import_asana: "Asanaインポート",
        import_monday: "Monday.comインポート",
        importing: "インポート中...",
        start_import: "インポート",
        linked_tasks: "リンクされたタスク",
        add_link: "タスクをリンク",
        remove_link: "リンクを解除",
        no_linked_tasks: "リンクされたタスクはまだありません",
        searching: "検索中...",
        add_reaction: "リアクションを追加",
    },
    Comments: {
        ...en.Comments,
        edit: "編集",
        reply: "返信",
        copy_message: "メッセージをコピー",
        more: "もっと見る",
        less: "閉じる",
        edited: "編集済み",
    },
    AI: {
        ...en.AI,
        ai_write_description: "AIで作成",
        ai_desc_intent_placeholder: "この説明には何を含めますか？（任意）",
        ai_desc_intent_hint: "空欄にするとタイトルから生成します。",
        ai_generate: "生成",
        ai_regenerate: "再生成",
        ai_use_this: "これを使用",
        ai_answer_questions: "正確な説明のために、いくつかの簡単な質問に答えてください：",
        ai_generating: "生成中…",
        ai_failed: "説明を生成できませんでした。もう一度お試しください。",
    },
};
